import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import AssetManagementApiService from './AssetManagementApiService'
import { GET_COST_CENTER } from '../../Store/AssetManagement/CostCenter/CostCenterType'
import { setCostCenter } from 'Store/AssetManagement/CostCenter/CostCenterAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getCostCenter(req: any): any {
    
    let payloadData : IPayload= {
        apiType : apiType.AssetManagement,
        endpoint : `assets/branches/${req.val}`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    
    try {
        yield put(globalLoaderText("Fetching Branch...."));

        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp,payloadData
        );
        
        yield put(setCostCenter(response))

        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(setCostCenter([]))
        yield put(globalLoaderText(""));
    }
}

function* watchGetCostCenter() {
    yield takeEvery(GET_COST_CENTER, getCostCenter)
}

export default function* combinedSaga() {
    yield all([
        watchGetCostCenter()
    ])
}
